import { render, staticRenderFns } from "./lvPrice.vue?vue&type=template&id=cf5d955e&scoped=true&"
import script from "./lvPrice.vue?vue&type=script&lang=js&"
export * from "./lvPrice.vue?vue&type=script&lang=js&"
import style0 from "./lvPrice.vue?vue&type=style&index=0&id=cf5d955e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf5d955e",
  null
  
)

export default component.exports